/* External */
import { useEffect, useState } from 'react';

/* Utils */
import platform from '../../../utils/platform';
import { reportLoadDrmAgentError } from '../../../services/gaService';

export default function useIsDrmAgentLoaded(keySystem) {
  const [isDrmAgentLoaded, setIsDrmAgentLoaded] = useState(false);

  useEffect(() => {
    async function awaitLoadDrmAgent() {
      setIsDrmAgentLoaded(await platform.loadDrmAgent(keySystem, reportLoadDrmAgentError));
    }

    awaitLoadDrmAgent();
    return () => {
      setIsDrmAgentLoaded(false);
    };
  }, [keySystem]);

  return isDrmAgentLoaded;
}
